module.exports = __webpack_public_path__ + "img/img19.43babca8.png";